import { observer } from "mobx-react";
import React, {useEffect, useState} from "react";
import {BranchAddress} from "../../../../../models/branches/branch-data";
import {branchesService} from "../../../../../services/branches/branches.service";
import {AddressList} from "../../../../branches/data/branch-data-addresses/address-list/address-list";
import {notifications} from "../../../../../services/notifications/notifications";
import {Space, Typography} from "antd";
import {useTranslate} from "../../../../../hooks/translate.hook";
import {useRequiredStore} from "../../../../../utils/store";
import {AgentDataStoreContext} from "../../agent.data.store";
import {accountService} from "../../../../../services/accounts/account.service";

export const AgentDataSeller: React.FC = observer(() => {
    const t = useTranslate();
    const store = useRequiredStore(AgentDataStoreContext);

    const [addresses, setAddresses] = useState<BranchAddress[]>([]);

    const [defaultId, setDefaultId] = useState<number>(store.account!.branchAddress.id);

    const reload = async () => {
        setAddresses(await branchesService.getAllCurrentBranchAddresses());
    }

    const setDefault = async (item: BranchAddress) => {
        await accountService.updateBranchAddress(store.account!.id, item.id);
        setDefaultId(item.id);
        notifications.successfully();
        await reload();
    }

    useEffect(() => {
        reload();
    }, [])

    return (
        <Space size={[0, 0]} direction={"vertical"}>
            <Typography.Title level={3}>
                {t("CLIENT.SELLER_DATA")}
            </Typography.Title>
            <AddressList
                setDefault={setDefault}
                defaultId={defaultId}
                addresses={addresses}
            />
        </Space>
    );
});
